import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDialog } from "../../../contexts/DialogContext";
import { useTranslation } from "react-i18next";
import {
  Card,
  CardHeader,
  Breadcrumbs as MuiBreadcrumbs,
  Paper as MuiPaper,
  Button,
  Typography,
  CardContent,
  Box,
} from "@mui/material";
import styled from "@emotion/styled";
import moment from "moment";
import { spacing } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import ActivateToolbar from "../../../components/ActivateToolbar";
import useWindowDimensions from "../../../utils/windowDimensions";
import useHotelManagement from "../../../hooks/useHotelManagement";
import useMainContentDimensions from "../../../utils/mainContentDimensions";
import ActivateUser from "../hotel_users/components/ActivateUser";
import AdvanceFilter from "./AdvanceFilter";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

function ActivateUsers(props) {
  const { isLoadingDownload, downloadFileType } = useHotelManagement();
  const { width: mainContentWidth } = useMainContentDimensions();

  const [selectedRows, setSelectedRows] = useState([]);

  const { state } = useLocation();
  const { t } = useTranslation();

  const currentPayload = {
    filters: [
      {
        fieldName: "expiration",
        fieldValue: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
        op: "lt",
        dataType: "date",
        condition: "and",
        isJoin: false,
        isEnum: false,
      },
    ],
    pagination: {
      pageNumber: 1,
      pageSize: 100,
    },
    sortFields: [
      {
        field: "radUserId",
        sort: "DESC",
      },
    ],
  };

  const [sortModel, setSortModel] = useState([
    {
      field: "updatedAt",
      sort: "desc",
    },
  ]);
  const { height } = useWindowDimensions();
  const { getAllHotelManagement, hotelManagements, paging, downloadFile } = useHotelManagement();
  const { openDialog } = useDialog();

  const [payload, setPayload] = useState(currentPayload);

  const [filterResetFunc, setFilterResetFunc] = useState(
    () => () => console.log("Refresh initialized"),
  );

  const fetchData = async () => {
    await getAllHotelManagement(payload);
  };

  const refreshPage = () => {
    setPayload(currentPayload);
    filterResetFunc();
  };

  const onPageChange = (newPaginationModel) => {
    console.log(newPaginationModel, "pagepage");

    const pagination = {
      pageNumber: newPaginationModel.page === 0 ? 1 : newPaginationModel.page + 1,
      pageSize: newPaginationModel.pageSize, // Update pageSize dynamically
    };

    setPayload((prev) => ({ ...prev, pagination }));
    setPaginationModel(newPaginationModel);
  };

  const breadCrump = () => {
    return (
      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Typography>HMS</Typography>
        <Typography>Activate Users</Typography>
        <Typography>List</Typography>
      </Breadcrumbs>
    );
  };

  useEffect(() => {
    fetchData();
  }, [payload]);

  const handleSortModelChange = (newModel) => {
    console.log(newModel, "newModel");
    if (newModel.length !== 0) {
      setSortModel(newModel);
      setPayload((prev) => ({ ...prev, sortFields: newModel }));
    }
  };

  console.log(hotelManagements, "datadatadata");

  const columns = [
    {
      field: "plan",
      headerName: "Plan Name",
      valueGetter: (params) => params?.planName,
      width: 200,
    },
    {
      field: "userName",
      headerName: "User Name",
      width: 200,
    },
    {
      field: "password",
      headerName: "Password",
      width: 130,
    },
    {
      field: "status",
      headerName: "Status",
      width: 130,
    },
  ];

  const openActivateDialog = () => {
    return openDialog(
      "activate_user",
      "Activate User",
      <ActivateUser selectedRows={selectedRows} refreshPage={refreshPage} />,
    );
  };

  const openFilterDialog = () => {
    return openDialog(
      "advance_filter",
      "Advance Filter",
      <AdvanceFilter
        payload={payload}
        setPayload={setPayload}
        setFilterResetFunc={setFilterResetFunc}
      />,
    );
  };

  return (
    <Card sx={{ width: "100%", maxWidth: mainContentWidth - 64 }}>
      <CardHeader
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" }, // Stack on small screens
          justifyContent: "space-between",
          alignItems: "flex-start", // Adjust alignment as needed
        }}
        action={
          <ActivateToolbar
            openActivateDialog={openActivateDialog}
            downloadFile={downloadFile}
            refreshPage={refreshPage}
            openFilterDialog={openFilterDialog}
            isLoadingDownload={isLoadingDownload}
            downloadFileType={downloadFileType}
          />
        }
        title={
          <Typography variant="h6" sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem" } }}>
            {t("activate_users")}
          </Typography>
        }
        subheader={<Box sx={{ display: "flex", flexWrap: "wrap" }}>{breadCrump()}</Box>}
      />
      <CardContent sx={{ height: height - 180, display: "flex", flexDirection: "column" }}>
        <Box sx={{ flex: 1, overflow: "auto" }}>
          <DataGrid
            columns={columns}
            rows={hotelManagements}
            refreshPage={refreshPage}
            getRowId={(row) => row["radUserId"]}
            rowCount={paging.totalNumberOfRecords}
            loading={false}
            rowsPerPageOptions={[5]}
            pagination
            page={paging.pageNumber}
            pageSize={paging.pageSize}
            paginationMode="server"
            onPageChange={(page) => onPageChange(page)}
            onPageSizeChange={(pageSize) => onPageChange(pageSize)}
            checkboxSelection
            sortingMode="server"
            sortModel={sortModel}
            onSortModelChange={handleSortModelChange}
            onRowSelectionModelChange={(newRowSelectionModel) => {
              const selectedRowData = hotelManagements.filter((row) =>
                newRowSelectionModel.includes(row.radUserId),
              );

              setSelectedRows(selectedRowData);
            }}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? "even-row" : "odd-row"
            }
            sx={{
              "& .MuiDataGrid-row.even-row": {
                backgroundColor: "#f9f9f9", // Light gray for even rows
              },
              "& .MuiDataGrid-row.odd-row": {
                backgroundColor: "#ffffff", // White for odd rows
              },
            }}
          />
        </Box>
      </CardContent>
    </Card>
  );
}

export default ActivateUsers;
